// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios';
import store from "./store";
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import Clipboard from 'v-clipboard'
Vue.use(Clipboard)
Vue.config.productionTip = false
Vue.use(ElementUI)

import VueKindEditor from '@/utils/kindeditor.js'
import '../static/kindeditor/themes/default/default.css'
import '../static/kindeditor/kindeditor-all.js'
import '../static/kindeditor/lang/zh-CN.js'
Vue.use(VueKindEditor)

window.axios = axios;

axios.defaults.baseURL =  process.env.API_ROOT
// axios.defaults.baseURL='https://api.motortime.com/admin/car'
axios.defaults.withCredentials = true
axios.defaults.timeout = 1000 * 3600
if(localStorage.getItem('token')) {
  store.dispatch('param/setToken', localStorage.getItem('token'))
}
axios.interceptors.response.use(response => {
  if(!response.data.state) {
    // Toast(response.data.error.join('，'))
  }
  if(response.data.state=='4001'){
    localStorage.clear()
    router.replace({
      name: 'Login',
    }, () => {})
  }else if(response.data.state=='404'){
    localStorage.clear()
    router.replace({
      name: 'Wrong',
    }, () => {})
  }
  return response
}, error => {
  switch (error.response.status) {
    case 500:
    this.$Message.info('服务器内部错误');
    // Toast('服务器内部错误')
    break;
    case 401:
    this.$Message.info('登录失效，请重新登录');
    // Toast('登录失效，请重新登录')
    break;
    case 403:
    this.$Message.info('禁止访问');
    // Toast('禁止访问')
    break;
  }
  return Promise.reject(error);
})
Vue.prototype.NumberMul = function(arg1, arg2) {
  var m = 0;
  var s1 = arg1.toString();
  var s2 = arg2.toString();
  try {
    m += s1.split(".")[1].length;
  } catch (e) {}
  try {
    m += s2.split(".")[1].length;
  } catch (e) {}
  
  return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
}
const Base64 = require('base64-js').Base64
Vue.directive('down', {
  inserted: (el, binding) => {
    el.style.cssText = 'cursor: pointer;color:write;'
    el.addEventListener('click', () => {
      console.log(binding.value)
      let link = document.createElement('a')
      let url = 'https://pic.motortime.com/' + binding.value
      // 这里是将url转成blob地址，
      fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
        link.href = URL.createObjectURL(blob)
        console.log(link.href)
        link.download = ''
        document.body.appendChild(link)
        link.click()
      })
    })
  }
})
new Vue({
  Base64,
  router,
  store,
  render: h => h(App)
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js